import React, { useRef, useState } from 'react';
import './stacked-carousel-container.styles.scss';
import { ResponsiveContainer, StackedCarousel } from 'react-stacked-center-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import ImageContainer from '../image-container/image-container.component';

const StackedCarouselContainer = ({
  itemArr
}) => {

  const [ cardName, setCardName ] = useState('');
  const [ cardIndex, setCardIndex ] = useState(null);
  const ref = useRef();

  function displayCardName(e) {
    // console.log(itemArr);
    const el = itemArr[e];
    setCardName(el.title.replace('Item Earned: ', ``));
    setCardIndex(`Item ${e + 1}:`);
  }

  return (
    <div className='stacked-carousel-container'>
      <div className='center-col'>{cardIndex}</div>
      <div className='center-col'>{cardName}</div>
      <ResponsiveContainer
        carouselRef={ref}
        render={(parentWidth, carouselRef) => {
          // If you want to use a ref to call the method of StackedCarousel, you cannot set the ref directly on the carousel component
          // This is because ResponsiveContainer will not render the carousel before its parent's width is determined
          // parentWidth is determined after your parent component mounts. Thus if you set the ref directly it will not work since the carousel is not rendered
          // Thus you need to pass your ref object to the ResponsiveContainer as the carouselRef prop and in your render function you will receive this ref object
          let currentVisibleSlide = 5;
          if (parentWidth <= 1440) currentVisibleSlide = 3;
          if (parentWidth <= 1080) currentVisibleSlide = 3;
          return (
            <StackedCarousel
              ref={carouselRef}
              slideComponent={Card}
              slideWidth={parentWidth < 800 ? parentWidth - 40 : 750}
              carouselWidth={parentWidth}
              data={itemArr}
              currentVisibleSlide={currentVisibleSlide}
              maxVisibleSlide={3}
              useGrabCursor
              customScales={[1, 0.85, 0.77]}
              onActiveSlideChange={ newCenterDataIndex => displayCardName(newCenterDataIndex) }
            />
          );
        }}
      />
      <div className='slider-buttons'>
        <button 
          className='g-button small-btn'
          onClick={() => ref.current?.goBack()}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <button 
          className='g-button small-btn'
          onClick={() => ref.current?.goNext()}
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
    </div>
  )
}

export default StackedCarouselContainer

// Very import to memoize your Slide component otherwise there might be performance issue
// At minimum your should do a simple React.memo(SlideComponent)
// If you want the absolute best performance then pass in a custom comparator function like below 
export const Card = React.memo(function (props) {
  const { data, dataIndex } = props;
  const { cover } = data[dataIndex];
  return (
    <div
      style={{
        width: "100%",
        height: 300,
        userSelect: "none",
      }}
      className="my-slide-component"
    >
      <ImageContainer
        className='my-slide-image'
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
          borderRadius: ".7rem",
        }}
        draggable={false}
        src={cover}
      />
    </div>
  );
});